




















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import {
    MapObject,
    SelectedChannel,
    FakeMapObject
} from '@/core/components/networkViewer/types';
import { Formatters } from '@/core/components/networkViewer/formatters';
import { LogisticsNetwork } from '@/dto/';
@Component({
    components: {
    }
})
export default class SVGCircle extends Vue {
    @Prop({ type: Number, required: false }) public x!: number;
    @Prop({ type: Number, required: false }) public y!: number;
    @Prop({ type: Boolean, required: true }) public selected!: boolean;
    @Prop({ type: Array, required: false }) public values!: number[];
    @Prop({ type: Object, required: true }) public network!: LogisticsNetwork;
    @Prop({ type: String, required: false }) public circleType!: string;
    @Prop({ type: Object, required: false }) public item!: MapObject;
    @Prop({ type: Object, required: false })
    public selectedChannel!: SelectedChannel;
    public isVehicle: boolean = false;
    @Prop({ type: Object, required: false })
    public fakeMapObject!: FakeMapObject;
    @Prop({ type: Boolean, required: false }) public achor!: boolean;

    public mounted() {
        if (this.item) {
            this.isVehicle = this.item?.objectType === 1;
        }
    }

    public selectMapObject(item: any, value: any) {
        this.$emit('selectMapObject', this.item, null);
    }

    private radius() {
        let result;
        if (this.circleType !== 'OH') {
            if (this.circleType !== 'Direct') {
                if (
                    this.selectedChannel === null ||
                    this.selectedChannel === undefined
                ) {
                    let value = 0;
                    let value2 = 0;
                    let value3 = 0;
                    let value4 = 0;

                    this.values.forEach(item => {
                        value += item;
                    });

                    if (this.circleType === 'Capacity') {
                        value2 = this.network.preferences.mapObject
                            .minDisplayCapacityRadius;
                        value3 = this.network.preferences.mapObject
                            .maxDisplayCapacityRadius;
                    } else {
                        value2 = this.network.preferences.mapObject
                            .minDisplayFlowRadius;
                        value3 = this.network.preferences.mapObject
                            .maxDisplayFlowRadius;
                    }

                    if (this.selected) {
                        value4 = this.network.state.mapObjects.maxCapacity ?? 0;
                    } else {
                        value4 = this.network.state.general.maxFlow;
                    }

                    result = Formatters.prototype.norm_square(
                        value,
                        0,
                        value4,
                        value2,
                        value3
                    );

                    if (this.circleType === 'Capacity') {
                        result = Formatters.prototype.add(result, 4);

                        if (this.selected) {
                            result = Formatters.prototype.add(
                                result,
                                this.network.preferences.selection.outlineWidth
                            );
                        } else {
                            result = Formatters.prototype.max(
                                result,
                                this.network.preferences.mapObject
                                    .minDisplayCapacityRadius
                            );
                        }
                    }

                    result = Formatters.prototype.ifNaN(result, 0);
                } else {
                    result = Formatters.prototype.div(
                        this.network.preferences.channel
                            .maxDisplayCapacityWidth,
                        2
                    );
                    if (this.circleType !== 'CTAB') {
                        result = Formatters.prototype.add(result, 8);
                    }
                }
            } else {
                result = this.fakeMapObject.r;
            }
        } else {
            result = this.network.preferences.selection.handleRadius;
        }
        return result;
    }

    private show() {
        if (
            this.circleType === 'Capacity' ||
            this.circleType === 'OH' ||
            this.circleType === 'CTAB' ||
            this.isVehicle
        ) {
            return true;
        }
        if (this.circleType === 'Flow') {
            return this.item.flow && this.item.flow > 0;
        }
        if (this.circleType === 'InfeasibleFlow') {
            return this.item.fixedFlow && this.item.fixedFlow > 0;
        }
        if (this.circleType === 'FixedFlow') {
            return this.item.infeasibleFlow && this.item.infeasibleFlow > 0;
        }
    }

    private getX() {
        if (this.circleType === 'Direct') {
            return this.fakeMapObject.x;
        }
        if (this.selected === false && !this.achor) {
            return this.x;
        } else {
            if (
                this.achor &&
                this.selectedChannel !== null &&
                this.selectedChannel !== undefined
            ) {
                const result = Formatters.prototype.svg_selected_channel_achor(
                    this.selectedChannel,
                    4,
                    this.network.preferences.channel.maxDisplayCapacityWidth
                );
                return result.x;
            } else {
                return this.network.state.selectedMapObject?.x;
            }
        }
    }

    private getY() {
        if (this.circleType === 'Direct') {
            return this.fakeMapObject.y;
        }
        if (this.selected === false && !this.achor) {
            return this.y;
        } else {
            if (
                this.achor &&
                this.selectedChannel !== null &&
                this.selectedChannel !== undefined
            ) {
                const result = Formatters.prototype.svg_selected_channel_achor(
                    this.selectedChannel,
                    4,
                    this.network.preferences.channel.maxDisplayCapacityWidth
                );
                return result.y;
            } else {
                return this.network.state.selectedMapObject?.y;
            }
        }
    }
}
